import type { SVGProps } from "react";

export function IconBlueArrowRightBase(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.5601 57V7L57.0045 32L12.5601 57Z"
        fill="#41D8F6"
        stroke="#41D8F6"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
      <path
        d="M12.5601 32H26.5601"
        stroke="#23232C"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
    </svg>
  );
}
